/**
 * État dans lequel une demande entre dans l'application.
 *
 * Deux écrans posent la même question — l'import Trello et la saisie manuelle
 * d'une demande — et doivent y répondre pareil : la liste vit donc ici.
 *
 * Tous les statuts de l'enum n'y figurent pas. Seulement ceux qu'une affaire
 * peut réellement avoir atteinte AILLEURS avant d'entrer : les états
 * transitoires (« à traiter » pendant la génération) ou posés par un geste de
 * l'application (« convocation envoyée ») ne se choisissent pas à la main.
 *
 * `STATUT_GENERANT` est le seul qui lance la rédaction automatique du devis.
 * Il vaut pour une demande NEUVE, et pour elle seule : entrer une affaire en
 * « devis envoyé » ou « contrat signé », c'est consigner un dossier dont le
 * devis existe déjà — souvent joint en pièce. En fabriquer un second ferait
 * deux devis concurrents pour un même client. Doit rester aligné sur
 * `generationAuto.STATUT_DECLENCHANT_GENERATION`, côté serveur.
 */
export const STATUT_GENERANT = 'a_traiter';

export const STATUTS_DEMANDE = [
  {
    valeur: 'a_traiter',
    label: 'Non traitée',
    note: 'demande neuve — le devis sera rédigé automatiquement',
  },
  { valeur: 'urgent', label: 'Urgente', note: 'à traiter en priorité, sans génération' },
  { valeur: 'traite', label: 'À valider', note: 'le devis existe et attend une relecture' },
  { valeur: 'devis_envoye', label: 'Devis envoyé', note: 'parti au client, en attente de réponse' },
  { valeur: 'devis_accepte', label: 'Devis accepté', note: 'le client a dit oui' },
  { valeur: 'contrat_signe', label: 'Contrat signé', note: 'le contrat est signé' },
  {
    valeur: 'convocation_envoye',
    label: 'Convocation envoyée',
    note: 'les participants ont reçu leur convocation',
  },
  {
    valeur: 'feuillepresence_envoye',
    label: 'Feuille de présence',
    note: 'dernière étape avant « Terminé » : il ne reste qu’à émarger',
  },
  { valeur: 'termine', label: 'Terminée', note: 'affaire close, rien à produire' },
  { valeur: 'sans_suite', label: 'Sans suite', note: 'abandonnée' },
];
